(function () {
  function initForm(form) {
    if (form.dataset.mcInitialized === 'true') return;
    form.dataset.mcInitialized = 'true';

    var action = form.dataset.mcAction || form.action;
    var section = form.closest('[data-mc-form-section]');
    if (!section) return;

    var formState = section.querySelector('[data-mc-state="form"]');
    var thanksState = section.querySelector('[data-mc-state="thanks"]');
    var errorEl = form.querySelector('[data-mc-error]');
    var submitBtn = form.querySelector('button[type="submit"]');

    function setLoading(loading) {
      if (!submitBtn) return;
      submitBtn.disabled = loading;
      submitBtn.classList.toggle('btn--loading', loading);
    }

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message || form.dataset.mcErrorGeneric;
      errorEl.hidden = false;
    }

    function hideError() {
      if (!errorEl) return;
      errorEl.textContent = '';
      errorEl.hidden = true;
    }

    function showThanks() {
      if (formState) formState.hidden = true;
      if (thanksState) {
        thanksState.hidden = false;
        try {
          thanksState.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } catch (e) {
          thanksState.scrollIntoView();
        }
      }
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      hideError();
      var invalidField = Array.from(form.elements).find(function (field) {
        return field.willValidate && !field.validity.valid;
      });
      if (invalidField) {
        showError(invalidField.validity.typeMismatch ? form.dataset.mcErrorEmail : form.dataset.mcErrorRequired);
        invalidField.focus();
        return;
      }
      setLoading(true);

      var jsonpUrl = action.replace('/post', '/post-json');
      var params = new URLSearchParams();
      var formData = new FormData(form);
      formData.forEach(function (value, key) {
        params.append(key, value);
      });

      var callbackName = 'mcCallback_' + Math.floor(Math.random() * 1000000);
      params.append('c', callbackName);

      var script = document.createElement('script');
      var settled = false;

      function cleanup() {
        if (settled) return;
        settled = true;
        try {
          delete window[callbackName];
        } catch (err) {
          window[callbackName] = undefined;
        }
        if (script.parentNode) script.parentNode.removeChild(script);
        setLoading(false);
      }

      window[callbackName] = function (response) {
        cleanup();
        if (response && response.result === 'success') {
          showThanks();
          if (form.dataset.mcSuccessUrl) {
            window.location.assign(form.dataset.mcSuccessUrl);
          }
        } else {
          var msg = response && response.msg ? String(response.msg).replace(/^\d+\s*-\s*/, '') : '';
          if (form.dataset.mcLocale === 'fr') {
            msg = /already subscribed|bereits.*angemeldet|déjà.*inscrit/i.test(msg)
              ? form.dataset.mcErrorSubscribed
              : form.dataset.mcErrorGeneric;
          }
          showError(msg);
        }
      };

      script.onerror = function () {
        cleanup();
        showError(form.dataset.mcErrorNetwork);
      };

      window.setTimeout(function () {
        if (!settled) {
          cleanup();
          showError(form.dataset.mcErrorTimeout);
        }
      }, 15000);

      var separator = jsonpUrl.indexOf('?') >= 0 ? '&' : '?';
      script.src = jsonpUrl + separator + params.toString();
      document.body.appendChild(script);
    });
  }

  function init() {
    document.querySelectorAll('[data-mc-form]').forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
